require("!!/code/frontend/node_modules/script-loader/addScript.js")(require("!!/code/frontend/node_modules/raw-loader/index.js!/code/frontend/node_modules/bootstrap/dist/js/bootstrap.min.js"))


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/script-loader!/code/frontend/~/bootstrap/dist/js/bootstrap.min.js
// module id = ../../../../script-loader/index.js!../../../../bootstrap/dist/js/bootstrap.min.js
// module chunks = 3